// İSG: sağlık raporu için gerekçeli "Maskeleme Düzeltmesi İste"
import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { EyeOff, Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { MASK_FIX_REASONS } from '../../lib/healthMask';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const MaskFixRequestButton = ({ employee, onDone }) => {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState('');
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);
  const needNote = reason === 'Diğer';

  const submit = async () => {
    setBusy(true);
    try {
      const res = await axios.post(`${API}/employees/${employee.id}/health-report/mask-fix`, { reason, note });
      toast.success('Maskeleme düzeltmesi istendi, firmaya bildirim gönderildi');
      setOpen(false);
      onDone(res.data);
    } catch (e) {
      toast.error(typeof e.response?.data?.detail === 'string' ? e.response.data.detail : 'İşlem başarısız');
    }
    setBusy(false);
  };

  return (
    <>
      <button type="button" onClick={() => { setReason(''); setNote(''); setOpen(true); }} data-testid="mask-fix-request-btn"
        className="flex w-full items-center justify-center gap-2 rounded-lg border-2 border-slate-800 bg-slate-900 px-3 py-2 text-sm font-semibold text-white transition-colors hover:bg-slate-700">
        <EyeOff className="h-4 w-4" />Maskeleme Düzeltmesi İste
      </button>
      <Dialog open={open} onOpenChange={(o) => !busy && setOpen(o)}>
        <DialogContent className="max-w-md" data-testid="mask-fix-dialog">
          <DialogHeader>
            <DialogTitle>Maskeleme Düzeltmesi İste</DialogTitle>
            <DialogDescription>{employee.name} {employee.surname} – Sağlık Raporu. Belge "Maskeleme Düzeltmesi Bekleniyor" olarak firmaya iade edilir.</DialogDescription>
          </DialogHeader>
          <div className="space-y-2" role="radiogroup">
            {MASK_FIX_REASONS.map((r, i) => (
              <label key={r} className={`flex cursor-pointer items-center gap-2 rounded-md border px-3 py-2 text-sm transition-colors ${reason === r ? 'border-slate-900 bg-slate-50 font-medium' : 'border-slate-200 hover:bg-slate-50'}`}>
                <input type="radio" name="mask-fix-reason" checked={reason === r} onChange={() => setReason(r)} data-testid={`mask-fix-reason-${i}`} />{r}
              </label>
            ))}
            <Textarea value={note} onChange={(e) => setNote(e.target.value)} rows={2} maxLength={500}
              placeholder={needNote ? 'Açıklama (zorunlu)' : 'Açıklama (isteğe bağlı) – sağlık bilgisi yazmayınız'} data-testid="mask-fix-note" />
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} disabled={busy}>Vazgeç</Button>
            <Button onClick={submit} disabled={busy || !reason || (needNote && !note.trim())} className="bg-slate-900" data-testid="mask-fix-submit">
              {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Düzeltme İste
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
